import { catAppAPIClient } from "@/app/apiClient";
import { ErrUnauthorised } from "@/app/api/Errors";
import { getCurrentUser } from "@/app/firebase/auth";
import { SearchUsersResponse } from "@anu-its/cat-grpc-pb/js/anu/cat_app/search_pb";

async function SearchUsers(
  query: string,
): Promise<SearchUsersResponse | Error | null> {
  const user = await getCurrentUser();
  if (!user) return ErrUnauthorised;

  if (query.length >= 3) {
    try {
      const request = { query: query };

      return await catAppAPIClient.searchUsers(request);
    } catch (err) {
      console.error("GetUsers failed:", err);
      throw new Error("Failed to get users. Please try again later.");
    }
  }

  return null;
}

export { SearchUsers };
